export const variants = [
	{
		handle: 'quilted-leather-floor-mats',
		variants: [
			{
				title: '4 Pc Mat Set',
				price: 849,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/87A252D9-10DF-48B0-850A-BFA893CBD3FA_1_200x.jpg?v=1664142546',
				id: '19255359733817',
				sku: 'LM-Q-BB1',
				available: true,
				selected: true,
				product_class: 'line_item',
				partNumber: 'BB1',
				part_number_note_list: [],
				selectedPartNumberNote: '',
				product_unique_list: [],
				selectedProductUnique: ''
			},
			{
				title: '2 Pc Fronts w/1 Pc Rear Car Mat',
				price: 849,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/1_2_68aa1612-d50b-451d-a7ce-3b1cecfdfc72_200x.jpg?v=1664142546',
				id: '19255359766585',
				sku: 'LM-Q-BB2',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '1 Pc Front w/2 Pc Rear Car Mats',
				price: 849,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/87A252D9-10DF-48B0-850A-BFA893CBD3FA_1_200x.jpg?v=1664142546',
				id: '19255359799353',
				sku: 'LM-Q-BB3',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '1 Pc Front Mat',
				price: 579,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/1_2_68aa1612-d50b-451d-a7ce-3b1cecfdfc72_200x.jpg?v=1664142546',
				id: '19255359832121',
				sku: 'LM-Q-BB4',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '2 Pc Front Mats',
				price: 579,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/1_2_68aa1612-d50b-451d-a7ce-3b1cecfdfc72_200x.jpg?v=1664142546',
				id: '19255359864889',
				sku: 'LM-Q-BB5',
				available: true,
				selected: false,
				product_class: 'line_item',
				partNumber: 'BB5',
				part_number_note_list: [],
				selectedPartNumberNote: '',
				product_unique_list: [],
				selectedProductUnique: ''
			},
			{
				title: '1 Pc 2nd Seat Mat',
				price: 300,
				images: '//cdn.shopify.com/s/files/1/0027/5539/5641/products/2_2_200x.jpg?v=1664142546',
				id: '19255359930425',
				sku: 'LM-Q-BB7',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '1 Pc Rear Car Mat',
				price: 300,
				images: '//cdn.shopify.com/s/files/1/0027/5539/5641/products/2_2_200x.jpg?v=1664142546',
				id: '19255359963193',
				sku: 'LM-Q-BB8',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '2 Pc 2nd Seat Mats',
				price: 300,
				images: '//cdn.shopify.com/s/files/1/0027/5539/5641/products/2_2_200x.jpg?v=1664142546',
				id: '19255360061497',
				sku: 'LM-Q-BB9',
				available: true,
				selected: false,
				product_class: 'line_item',
				partNumber: 'BB9',
				part_number_note_list: [],
				selectedPartNumberNote: '',
				product_unique_list: [],
				selectedProductUnique: ''
			},
			{
				title: '1 Pc 3rd Seat Mat',
				price: 300,
				images: '//cdn.shopify.com/s/files/1/0027/5539/5641/products/2_2_200x.jpg?v=1664142546',
				id: '19255360094265',
				sku: 'LM-Q-BB10',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '2 Pc 3rd Seat Mats',
				price: 300,
				images: '//cdn.shopify.com/s/files/1/0027/5539/5641/products/2_2_200x.jpg?v=1664142546',
				id: '19255360127033',
				sku: 'LM-Q-BB11',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '2nd & 3rd Seat',
				price: 600,
				images: '//cdn.shopify.com/s/files/1/0027/5539/5641/products/2_2_200x.jpg?v=1664142546',
				id: '19255360159801',
				sku: 'LM-Q-BB12',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: 'Small Cargo Mat',
				price: 649,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/3_1_b9a248c2-1c3e-405e-ba56-25deae9a9d73_200x.jpg?v=1664142546',
				id: '19255360192569',
				sku: 'LM-Q-BB13',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: 'Small Deck Mat',
				price: 649,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/3_1_b9a248c2-1c3e-405e-ba56-25deae9a9d73_200x.jpg?v=1664142546',
				id: '19255360225337',
				sku: 'LM-Q-BB14',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: 'Small Trunk Area Mat',
				price: 649,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/3_1_b9a248c2-1c3e-405e-ba56-25deae9a9d73_200x.jpg?v=1664142546',
				id: '19255360258105',
				sku: 'LM-Q-BB15',
				available: true,
				selected: false,
				product_class: 'line_item',
				partNumber: 'BB15',
				part_number_note_list: [],
				selectedPartNumberNote: '',
				product_unique_list: [],
				selectedProductUnique: ''
			},
			{
				title: 'Standard Cargo Area Mat',
				price: 649,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/3_1_b9a248c2-1c3e-405e-ba56-25deae9a9d73_200x.jpg?v=1664142546',
				id: '19255360290873',
				sku: 'LM-Q-BB16',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: 'Standard Deck Mat',
				price: 649,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/3_1_b9a248c2-1c3e-405e-ba56-25deae9a9d73_200x.jpg?v=1664142546',
				id: '19255360323641',
				sku: 'LM-Q-BB17',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: 'Standard Trunk Area Mat',
				price: 649,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/3_1_b9a248c2-1c3e-405e-ba56-25deae9a9d73_200x.jpg?v=1664142546',
				id: '19255360356409',
				sku: 'LM-Q-BB19',
				available: false,
				selected: false,
				product_class: 'line_item'
			}
		]
	},
	{
		handle: 'carbon-fiber-floor-mats',
		variants: [
			{
				title: '4 Pc Mat Set',
				price: 1599,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/diablose30jotacarbonfiberfloormats_1of5_-8_200x.jpg?v=1597545077',
				id: '31451650359353',
				sku: 'OTH-CFLM-BB1',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '2 Pc Fronts w/1 Pc Rear Car Mat',
				price: 1799,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/2_848e1c25-0a9a-49ec-be7b-7eaaa1a96be9_200x.jpg?v=1597545077',
				id: '31451650392121',
				sku: 'OTH-CFLM-BB2',
				available: true,
				selected: true,
				product_class: 'line_item',
				partNumber: 'BB2',
				part_number_note_list: [],
				selectedPartNumberNote: '',
				product_unique_list: [],
				selectedProductUnique: ''
			},
			{
				title: '1 Pc Front w/2 Pc Rear Car Mats',
				price: 1799,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/1_8aac5f22-e2c1-4af7-9126-be69419f46c5_200x.jpg?v=1597545077',
				id: '31451650424889',
				sku: 'OTH-CFLM-BB3',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '1 Pc Front Mat',
				price: 1299,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/1_8aac5f22-e2c1-4af7-9126-be69419f46c5_200x.jpg?v=1597545077',
				id: '31451650457657',
				sku: 'OTH-CFLM-BB4',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '2 Pc Front Mats',
				price: 1299,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/1_8aac5f22-e2c1-4af7-9126-be69419f46c5_200x.jpg?v=1597545077',
				id: '31451650490425',
				sku: 'OTH-CFLM-BB5',
				available: true,
				selected: false,
				product_class: 'line_item',
				partNumber: 'BB5',
				part_number_note_list: [],
				selectedPartNumberNote: '',
				product_unique_list: [],
				selectedProductUnique: ''
			},
			{
				title: '1 Pc 2nd Seat Mat',
				price: 799,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/2_848e1c25-0a9a-49ec-be7b-7eaaa1a96be9_200x.jpg?v=1597545077',
				id: '31451650523193',
				sku: 'OTH-CFLM-BB7',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '1 Pc Rear Car Mat',
				price: 799,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/2_848e1c25-0a9a-49ec-be7b-7eaaa1a96be9_200x.jpg?v=1597545077',
				id: '31451650555961',
				sku: 'OTH-CFLM-BB8',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '2 Pc 2nd Seat Mats',
				price: 799,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/2_848e1c25-0a9a-49ec-be7b-7eaaa1a96be9_200x.jpg?v=1597545077',
				id: '31451650588729',
				sku: 'OTH-CFLM-BB9',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '1 Pc 3rd Seat Mat',
				price: 799,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/2_848e1c25-0a9a-49ec-be7b-7eaaa1a96be9_200x.jpg?v=1597545077',
				id: '31451650621497',
				sku: 'OTH-CFLM-BB10',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '2 Pc 3rd Seat Mats',
				price: 799,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/2_848e1c25-0a9a-49ec-be7b-7eaaa1a96be9_200x.jpg?v=1597545077',
				id: '31451650654265',
				sku: 'OTH-CFLM-BB11',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: '2nd & 3rd Seat',
				price: 1199,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/2_848e1c25-0a9a-49ec-be7b-7eaaa1a96be9_200x.jpg?v=1597545077',
				id: '31451650687033',
				sku: 'OTH-CFLM-BB12',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: 'Small Cargo Mat',
				price: 999,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/3_e24a8d72-8d2f-4b4b-b34b-86fcf58c0fa0_200x.jpg?v=1597545077',
				id: '31451650719801',
				sku: 'OTH-CFLM-BB13',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: 'Small Deck Mat',
				price: 999,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/3_e24a8d72-8d2f-4b4b-b34b-86fcf58c0fa0_200x.jpg?v=1597545077',
				id: '31451650752569',
				sku: 'OTH-CFLM-BB14',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: 'Small Trunk Area Mat',
				price: 999,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/3_e24a8d72-8d2f-4b4b-b34b-86fcf58c0fa0_200x.jpg?v=1597545077',
				id: '31451650785337',
				sku: 'OTH-CFLM-BB15',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: 'Standard Cargo Area Mat',
				price: 1299,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/3_e24a8d72-8d2f-4b4b-b34b-86fcf58c0fa0_200x.jpg?v=1597545077',
				id: '31451650818105',
				sku: 'OTH-CFLM-BB16',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: 'Standard Deck Mat',
				price: 1299,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/3_e24a8d72-8d2f-4b4b-b34b-86fcf58c0fa0_200x.jpg?v=1597545077',
				id: '31451650850873',
				sku: 'OTH-CFLM-BB17',
				available: false,
				selected: false,
				product_class: 'line_item'
			},
			{
				title: 'Standard Trunk Area Mat',
				price: 1299,
				images:
					'//cdn.shopify.com/s/files/1/0027/5539/5641/products/3_e24a8d72-8d2f-4b4b-b34b-86fcf58c0fa0_200x.jpg?v=1597545077',
				id: '31451650883641',
				sku: 'OTH-CFLM-BB19',
				available: true,
				selected: false,
				product_class: 'line_item',
				partNumber: 'BB19',
				part_number_note_list: [],
				selectedPartNumberNote: '',
				product_unique_list: [],
				selectedProductUnique: ''
			}
		]
	}
];
